import {
  React,
  useState,
  useContext,
  useEffect,
  useRef,
  useCallback,
  useMemo,
} from "react";
import {
  descriptionCharLimit,
  exportPdf,
  getFundsDetailPage,
} from "../../Config/config";
import {
  // useSearchParams,
  // Routes,
  // Route,
  useParams,
  NavLink,
} from "react-router-dom";
import axios from "axios";
import compare from "../../images/compare.png";
import addNoted from "../../images/AtomFavourite Copy/png/AtomFavourite Copy.png";
import addNotedActive from "../../images/AtomFavourite Copy 3/png/AtomFavourite Copy 3.png";
import { CompareCompanyContext } from "../../Contexts/CompareCompanyContext";
import ComparePopUp from "../../Pages/ComparePopUp";
import AddNote from "../../Pages/addNote";
import AlertPopUp from "../../Components/DetailPage/AlertPopUp";
import PENotesPopup from "../../Components/NotesPopup/PENotesPopup";
import SendDealPopUp from "../../Components/SendDealPopUp";
import { routeNames } from "../../routeSegments";
import Constants from "../../Constants";
import useModule from "../../hooks/useModule";
import PdfDownloader from "../shared/PdfDownloader";
import { UserContext } from "../../Contexts/UserContext";
import AddNotePopover from "../shared/AddNotePopover";
import { PeFilterContext } from "../../Contexts/PeFilterContext";
import NewLogo from "../NewLogo";
import Tab from "../shared/Tab";
import FundProfile from "./FundProfile";
import { useInView } from "react-intersection-observer";
import { debounce, delay } from "lodash";
import Loader from "../Loader";
import FundInvestments from "./FundInvestments";

const CompanyDealDetail = () => {

  const { groupId, setGroupId, accessControl } = useContext(PeFilterContext);
  // const { companyDetail, setCompanyDetail, } = useContext(CompareCompanyContext);

  const { fundId: fid } = useParams();
  const { isVC } = useModule();
  const [currentId, setCurrentId] = useState();

  const [note] = useState(false);

  const [showNote, setShowNote] = useState(false);

  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);
  const [activeBtn, setActiveBtn] = useState(1);
  const [fundNameId, setFundNameId] = useState(fid);
  var firmName;
  var fundId;
  const [active, setActive] = useState(1);
  const [skipScroll, setSkipScroll] = useState(false);
  const { getToken } = useContext(UserContext);

  /**
   * Function to extract unique industries from fund portfolio data
   * @param {Array} fundPortfolio - Array of investment objects
   * @returns {string} - Comma-separated string of unique industries
   */
  const getUniqueIndustries = (fundPortfolio) => {
    if (!fundPortfolio || !Array.isArray(fundPortfolio)) {
      return "";
    }

    const industries = fundPortfolio
      .map(investment => investment?.industry)
      .filter(industry => industry && industry.trim() !== "")
      .filter((industry, index, arr) => arr.indexOf(industry) === index); // Remove duplicates

    return industries.join(", ");
  };

  const menuRef = useRef();

  useEffect(() => {
    getFundsDetail(fundId);
  }, []);

  const getFundsDetail = useCallback(() => {
    setLoading(true);
    axios(`${getFundsDetailPage}`, {
      method: "POST",
      headers: {
        authorization: getToken(),
        "Content-Type": "application/json",
      },
      data: {
        fund_id: fundNameId,
        db_type: isVC ? "VC" : "PE",
        industry_ids: accessControl?.peindustries?.id,
        country_ids: accessControl?.pe_countries?.id,
        region_ids: accessControl?.pe_regions?.id,
        state_ids: accessControl?.pe_states?.id,
        city_ids: accessControl?.pe_cities?.id,
        tag_ids: accessControl?.pe_tags.name,
        stage_ids: accessControl?.pe_stage?.id,
        deal_range: accessControl.pe_deal_range,
      },
    })
      .then((response) => {
        if (response.status == "200") {
          console.log(response.data?.data, "getFunds");
          setLoading(false);
          setData(response?.data?.data);
        }
      })
      .catch((error) => {
        console.log("API not working", error);
      });
  }, [isVC]);

  const overview = () => {document.getElementById("profile").scrollIntoView({ behavior: "smooth" });};
  const investments = () => {document.getElementById("investments").scrollIntoView({ behavior: "smooth" })};

  const [overviewEl, isOverviewVisible] = useInView({threshold: 0.5, rootMargin: "60px 0px 0px 0px", skip: skipScroll});
  const [investmentsEl, isInvestmentsVisible] = useInView({threshold: 0.5, rootMargin: "60px 0px 0px 0px", skip: skipScroll});

  const [isActive, setIsActive] = useState(1);

  const onTabClick = (tabIndex) => {
    setSkipScroll(true);
    delay(() => {
      setSkipScroll(false);
    }, 500);
    if (tabIndex === 1) {
      overview();
    } else if (tabIndex === 2) {
      investments();
    }

    setIsActive(tabIndex);
  };

  const setIsActiveOnScroll = useMemo(() => {
    return debounce((index) => setIsActive(index), 100);
  }, []);

  useEffect(() => {
    if (isOverviewVisible) {
      setIsActiveOnScroll(1);
    } else if (isInvestmentsVisible) {
      setIsActiveOnScroll(2);
    }
  }, [isOverviewVisible, isInvestmentsVisible, setIsActiveOnScroll]);

  return (
    <>
      <div className="bg-[#FFFFFF]">
        {loading ? (
          <div className="h-[10rem] w-full bg-[#FFFFFF] flex items-center justify-center">
            <Loader />
          </div>
        ) : (
          <div className="col-span-5 md:col-span-4 font-sans_book_body Sans] bg-[#FFFFFF]">
            <nav
              className=" flex p-1 lg:px-2 px-3 border-b "
              aria-label="Breadcrumb"
            >
              <ol role="list" className="flex items-center space-x-1">
                <li className="flex items-center">
                  <div className="flex items-center">
                    <NavLink
                      onClick={() => setGroupId({})}
                      to={isVC ? routeNames.vc_investors_vc_investments : routeNames.pe_investors_pe_vc_investments}
                      className="ml-2  text-[12pt] lg:text-[12px] text-[#666666] font-sans_book_body leading-[14px]"
                    >
                      Investor
                    </NavLink>
                  </div>
                </li>

                <li>
                  <div className="flex items-center">
                    <span className=" text-[12px] text-[#666666] ">/</span>
                    <NavLink
                      to={isVC ? routeNames.vc_investors_vc_funds : routeNames.pe_investors_pe_vc_funds}
                      className=" ml-1 text-[11pt] lg:text-[12px]  leading-[14px] font-sans_book_body text-[#666666]"
                    >
                      Funds
                    </NavLink>
                  </div>
                </li>
                <li>
                  {data ? (
                    <div className="flex items-center">
                      <span className=" text-[12px] text-[#666666] font-medium">
                        /
                      </span>
                      <div className="leading-[25px] mb-[0.2rem]">
                        <span className=" text-[12px] leading-[14px] font-sans_book_body text-[#666666] pl-1 font-semibold">
                          {data?.profile?.fund_name}
                        </span>
                      </div>
                    </div>
                  ) : (
                    <>
                      <center>
                        <div className="w-full bg-[#FFFFFF]">
                          <div role="status" className="bg-white">
                            <svg
                              className="relative top-[0rem] inline mr-2 w-10 h-screen text-gray-200 animate-spin dark:text-gray-600 fill-[#CA8A24]"
                              viewBox="0 0 100 101"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                fill="currentColor"
                              />
                              <path
                                d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                fill="currentFill"
                              />
                            </svg>
                          </div>
                        </div>
                      </center>
                    </>
                  )}
                </li>
              </ol>
            </nav>
            <div className="px-5">
              <div className="lg:hidden mt-3  grid  md:grid-cols-8  grid-cols-10  items-center mb-4">
                {/* <div
                  className=" md:col-span-6 col-span-5"
                  title="Compare Company"
                >
                  <button
                    className={
                      showModal
                        ? "bg-[#BC8B20] text-white text-[14px] py-1 lg:py-1 px-2 lg:px:4 border border-[#DDDDDD] rounded-[4px] inline-flex items-center font-sans_book_body"
                        : "bg-[#FFFFFF] text-[#666666] text-[14px] py-1 lg:py-1 px-2 lg:px:4 border border-[#DDDDDD] rounded-[4px] inline-flex items-center font-sans_book_body"
                    }
                    type="button"
                    onClick={() => {
                      setShowModal(!showModal);
                      setCompanyDetail([]);
                    }}
                  >
                    <img
                      className={
                        showModal ? "pr-1 brightness-0 invert-[1]" : "pr-1"
                      }
                      src={compare}
                      alt=""
                    />
                    <span>Compare</span>
                  </button>
                </div> */}
                <div className="flex md:col-span-2 col-span-5 space-x-3">
                  {/* <div>
                    <AlertPopUp
                      type_id={Constants.fundsId}
                      cid={data?.profile?.investor_id}
                    />
                  </div> */}
                  {/* <div>
                    {/* <OutsideClickHandler onOutsideClick={() => { setShowNote(false); }} >
                    <span ref={menuRef}>
                      <img
                        className=" cursor-pointer w-[24px] h-[22px]"
                        src={showNote ? addNotedActive : addNoted}
                        onClick={() => setShowNote(!showNote)}
                        alt=""
                      />
                      {showNote ? (
                        <AddNote
                          module="funds"
                          page="detailpage"
                          type_id={Constants.fundsProfileId}
                          cname={data?.profile?.fund_name}
                          cid={fundNameId ?? fundId}
                          investor_id={data?.profile?.investor_id}
                          sub_type_master_id={
                            Constants.subCategoryIds.funds_profile
                          }
                        />
                      ) : (
                        ""
                      )}
                    </span>
                  </div> */}

                  <div className="col-span-1">
                    <PENotesPopup
                      note={note}
                      cid={Constants.fundsProfileId}
                      type_id={Constants.fund_id}
                    />
                  </div>
                  <div className="col-span-1">
                    {data?.profile?.fund_name && (
                      <SendDealPopUp
                        data={
                          data?.profile?.fund_name
                            ? data?.profile?.fund_name?.replaceAll(/\s/g, "")
                            : firmName?.replaceAll(/\s/g, "") + " Fund"
                        }
                      />
                    )}
                  </div>

                  <div>
                      <PdfDownloader
                        url={exportPdf}
                        fileName={data?.profile?.fund_name?.replaceAll(/\s/g, "") ?? "Fund_Profile"}
                        data={{
                          fund_id: fid,
                          type_id: 8,
                          "city_ids": accessControl?.pe_cities?.id,
                          "country_ids": accessControl?.pe_countries?.id,
                          "region_ids": accessControl?.pe_regions?.id,
                          "state_ids": accessControl?.pe_states?.id,
                          "industry_ids": accessControl?.peindustries?.id,
                          "tag_ids": accessControl?.pe_tags.name,
                          "stage_ids": accessControl?.pe_stage?.id,
                          "deal_range": {
                          "currency": accessControl?.pe_deal_range?.currency,
                            "from": accessControl?.pe_deal_range?.from,
                            "to": accessControl?.pe_deal_range?.to
                          }
                        }}
                      />
                  </div>
                </div>
              </div>
              <div className="  py-4 bg-[#FFFFFF]">
                <ul role="list">
                  <li className="w-full flex ">
                    <div className="  rounded-md bg-white ">
                      <NewLogo
                        menu="investor"
                        page={"detail page"}
                        id={data?.profile?.investor_id}
                        name={data?.profile?.investor_name}
                      />
                    </div>

                    <div className="ml-3 lg:px-3 flex flex-1 flex-col pl-3 lg:pl-0">
                      <div>
                        <p
                          key={data?.profile?.fund_id}
                          className="text-[#333333] text-[22px] font-semibold leading-[24px]"
                        >
                          {data?.profile?.fund_name}
                        </p>
                      </div>
                      <div>
                        <a
                          className=" text-[12pt] leading-[16pt] text-[#333333]  lg:text-[13px] lg:leading-[17px] font-sans_roman_body"
                          href={isVC ? routeNames.vcInvestorById(data?.profile?.investor_id) : `/pe/investor/${data?.profile?.investor_id}`}
                        >
                          {data?.profile?.investor_name}
                        </a>
                      </div>
                    </div>

                    <div className="hidden lg:grid grid-cols-8  gap-2">
                      <div className="col-span-3 mt-2"></div>

                      <div className="col-span-5 mt-[5px]">
                        <div className="grid grid-cols-3 gap-2 flex items-center">
                          {/* <div className="col-span-1 ">
                            <AlertPopUp
                              cid={data?.profile?.investor_id}
                              type_id={Constants.fundsProfileId}
                              page="fundDetail"
                            />{" "}
                          </div> */}

                          {/* <div className="col-span-1" ref={menuRef}>
                            <AddNotePopover
                              title="Save List"
                              companyId={fundNameId}
                              companyName={data?.profile?.fund_name?.replaceAll(/\s/g, "")}
                              type_id={Constants.moduleIds.fundsProfileId}
                              investor_id={data?.profile?.investor_id}
                              deal_id={parseInt(currentId)}
                              sub_type_master_id={
                                (isVC ? Constants.subCategoryIds.vc_funds_id : Constants.subCategoryIds.pe_funds_id)
                              }
                              IsDetailed={true}
                            />
                          </div> */}
                          <div className="col-span-1 mt-1">
                            <PENotesPopup
                              note={note}
                              cid={Constants.fundsProfileId}
                              type_id={Constants.fund_id}
                            />
                          </div>
                          <div className="col-span-1 mt-1">
                            {
                              <SendDealPopUp
                                data={
                                  data?.profile?.fund_name
                                    ? data?.profile?.fund_name?.replaceAll(/\s/g, "")
                                    : firmName?.replaceAll(/\s/g, "") + " Fund"
                                }
                              />
                            }
                          </div>
                          <div className="col-span-1">
                            <PdfDownloader
                              url={exportPdf}
                              fileName={data?.profile?.fund_name?.replaceAll(/\s/g, "") ?? "Fund_Profile"}
                              data={{
                                fund_id: fid,
                                type_id: 8,
                                "city_ids": accessControl?.pe_cities?.id,
                                "country_ids": accessControl?.pe_countries?.id,
                                "region_ids": accessControl?.pe_regions?.id,
                                "state_ids": accessControl?.pe_states?.id,
                                "industry_ids": accessControl?.peindustries?.id,
                                "tag_ids": accessControl?.pe_tags.name,
                                "stage_ids": accessControl?.pe_stage?.id,
                                "deal_range": {
                                "currency": accessControl?.pe_deal_range?.currency,
                                  "from": accessControl?.pe_deal_range?.from,
                                  "to": accessControl?.pe_deal_range?.to
                                }
                            }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
              {data?.fund_portfolio?.length !== 0 ? <div>
                  <p className="text-[11pt] leading-[17pt] lg:block lg:leading-[16px] mb-2 text-[#333333]  lg:text-[14px] font-sans_book_body mr-3 ">
                      Industries (Existing Investments): {getUniqueIndustries(data?.fund_portfolio)}
                  </p>
              </div> : <></>}
            </div>
            <div className="bg-[#EDEDED]">
              <div className="flex flex-row overflow-x-auto scrollbar space-x-6 bg-white px-6 pt-1  border-b border-[#D7D7D7] cursor-pointer sticky top-0  custom-z-index scrollbar-remove detail-tabs">
                <Tab
                  active={isActive === 1}
                  label={"Overview"}
                  onClick={() => onTabClick(1)}
                />
                <Tab
                  active={isActive === 2}
                  label={"Investments"}
                  onClick={() => onTabClick(2)}
                />
              </div>
              <div className="h-full space-y-5 sections-items">
                <section ref={overviewEl} className="scroll-mt-14" id="profile">
                  <FundProfile data={data} />
                </section>
                <section
                  ref={investmentsEl}
                  id="investments"
                  className="scroll-mt-14"
                >
                  <FundInvestments investmentsData={data?.fund_portfolio} data={data} />
                </section>
              </div>
            </div>
            {/* </div> */}
          </div>
        )}
      </div>
    </>
  );
};
export default CompanyDealDetail;